import AffiliateNotificationsField from '@apps/maha/admin/components/affiliate_notifications_field'
import SourceToken from '@admin/tokens/source'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Edit extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    modal: PropTypes.object
  }

  static propTypes = {
    affiliate: PropTypes.object
  }

  state = {
    config: {}
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { affiliate } = this.props
    const { config } = this.state
    return {
      title: 't(Edit Affiliate)',
      method: 'PATCH',
      endpoint: `/api/admin/truevail/admin/affiliates/${affiliate.id}/edit`,
      action: `/api/admin/truevail/admin/affiliates/${affiliate.id}`,
      onCancel: this._handleCancel,
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Send payouts to)', 
              type: 'segment',
              fields: [
                {
                  name: 'service',
                  type: 'radiogroup',
                  options: [
                    { source_name: 'paypal', name: 'Paypal' },
                    { source_name: 'venmo', name: 'Venmo' }
                  ],
                  format: (source) => <SourceToken source={ source } />,
                  valueKey: 'source_name',
                  defaultValue: 'paypal',
                  required: true
                },
                {
                  label: 't(Paypal Email)',
                  name: 'service_id',
                  type: 'emailfield',
                  show: config.service === 'paypal',
                  required: true
                },
                {
                  label: 't(Venmo Username)',
                  name: 'service_id',
                  type: 'textfield',
                  show: config.service === 'venmo',
                  required: true
                }
              ]
            },
            { 
              label: 't(Commission Rate)', 
              name: 'rate', 
              type: 'ratefield',
              required: true,
              defaultValue: 0.1,
              precision: 2
            },
            {
              label: 't(Notifications)',
              name: 'notifications',
              type: AffiliateNotificationsField
            }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSuccess(agency) {
    this.context.modal.close()
  }

}

export default Edit
